import { useEffect, useState } from 'react';
import { ApiError, fetchBrand, locationLabel, type PublicBrand } from '../api';
import { applyBrandColor } from '../theme';
import { BookPage } from './book';

/** Buchungsseite eines Auftritts: Liste der Terminarten als Karte, dahinter die Terminwahl (book.tsx). */
export function BrandPage({ slug, eventTypeSlug }: { slug: string; eventTypeSlug: string | null }) {
  const [brand, setBrand] = useState<PublicBrand | null | undefined>(undefined);

  useEffect(() => {
    fetchBrand(slug)
      .then((b) => {
        setBrand(b);
        applyBrandColor(b.brandColor);
        document.title = b.name;
      })
      .catch((e) => setBrand(e instanceof ApiError && e.status === 404 ? null : null));
  }, [slug]);

  if (brand === undefined) return null;
  if (brand === null) {
    return (
      <main className="page page--message">
        <h1>Diese Seite gibt es nicht</h1>
        <p className="muted">Bitte prüfe den Link, den du bekommen hast.</p>
      </main>
    );
  }

  const selected = eventTypeSlug ? brand.eventTypes.find((t) => t.slug === eventTypeSlug) : undefined;

  return (
    <>
      <main className={`page${selected ? ' page--wide' : ''}`}>
        {selected ? (
          <>
            <BookPage brand={brand} eventType={selected} />
            {brand.eventTypes.length > 1 && (
              <p className="small">
                <a href={`/${brand.slug}`}>← Alle Terminarten</a>
              </p>
            )}
          </>
        ) : (
          <section className="scheduler scheduler--list">
            <div className="scheduler__head">
              {brand.logoUrl ? <img className="scheduler__logo" src={brand.logoUrl} alt="" /> : <span className="scheduler__avatar">{brand.name.trim().charAt(0).toUpperCase()}</span>}
              <div>
                <p className="scheduler__brand">{brand.name}</p>
                <h1 className="scheduler__title">Termin buchen</h1>
                <p className="muted">Such dir aus, worum es gehen soll.</p>
              </div>
            </div>
            {brand.eventTypes.length === 0 && <p className="muted">Zurzeit lässt sich hier nichts buchen.</p>}
            {brand.eventTypes.length > 0 && (
              <ul className="type-list">
                {brand.eventTypes.map((t) => (
                  <li key={t.slug}>
                    <a className="type-list__row" href={`/${brand.slug}/${t.slug}`}>
                      <span className="type-list__text">
                        <strong>{t.title}</strong>
                        {t.description && <span className="muted small type-list__desc">{t.description}</span>}
                        <span className="muted small">
                          {t.durationMinutes} Minuten · {locationLabel(t.location)}
                        </span>
                      </span>
                      <span className="type-list__arrow" aria-hidden="true">
                        →
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </section>
        )}
        <p className="faint small">Alle Zeiten in deutscher Zeit.</p>
      </main>
      {(brand.imprintUrl || brand.privacyUrl) && (
        <footer className="footer">
          {brand.imprintUrl && <a href={brand.imprintUrl}>Impressum</a>}
          {brand.privacyUrl && <a href={brand.privacyUrl}>Datenschutz</a>}
        </footer>
      )}
    </>
  );
}
